import { noop, } from 'utils/fn';
import { ads, pageDomain, } from 'application/pageDataObject';
import { m, mithrilHelpers, } from 'utils/mithril';
import { toggleBemClass, bem, node, } from 'utils/dom';
import { addOnOrientationChangeEvent } from 'utils/window';
import SocialButtonsBaseView from './SocialButtonsBaseView';
import { SELECTORS, } from 'config/preRenderedSelectorsConfig';
import { registerHamburger, } from 'components/hamburger/hamburger';
import {
  platform, isDesktop, isMobileOrTablet,
  isIos, isMobile, isTablet, viewport,
} from 'utils/ua';


let pageWrap = null;
let headerNode = null;
function getHeaderNode(){
  headerNode = headerNode || node(SELECTORS.SITE_HEADER);
  return headerNode;
}
let headerAdNode = null;


const px = num => `${ num }px`;

function addHeaderMargins(vm) {
  const { mobileHeaderTop, } = vm;
  const marginTop = mobileHeaderTop === 0 ? 0 : mobileHeaderTop - 1;
  headerAdNode = headerAdNode || node(SELECTORS.HEADER_AD_UNIT);
  if (!isTablet || viewport.isPortrait) {
    getHeaderNode().style.marginTop = px(marginTop);
  } else {
    headerAdNode.classList.add('isTablet');
  }
  pageWrap = pageWrap || node(SELECTORS.PAGE_WRAP);
  pageWrap.style.marginTop = px(44 + headerAdNode.clientHeight);
}

function removeHeaderMargins() {
  headerAdNode = headerAdNode || node(SELECTORS.HEADER_AD_UNIT);
  if (isTablet || viewport.orientation === 'landscape') {
    getHeaderNode().style.marginTop = px(0);
  } else {
    headerAdNode.classList.remove('isTablet');
  }
  pageWrap = pageWrap || node(SELECTORS.PAGE_WRAP);
  pageWrap.style.marginTop = px(0);
}

export default class NavbarView extends SocialButtonsBaseView {

  view(ctrl){
    super.view(ctrl);
    return mithrilHelpers.createElementWithCallback('.navbar-shared-component', {
      callback: this.viewRenderCallback(ctrl),
      children: this.getCurrentView(ctrl.vm),
    });
  }

  viewRenderCallback(ctrl){
    let { vm, } = ctrl;
    return (element, isInit, context) => {
      if (!isInit) {
        vm.registerScrollingActions();
        this.registerHamburgerActions();
        this.mobileHeaderOrientationHandler(vm);
      }
    };
  }

  get isMobileOrPortraitTablet(){
    return isMobile || isTablet;
  }

  getCurrentView(vm){
    let { stickyEnabledView, stickyDisabledView } = this;
    let currentViewMethod = vm.store.isStickyEnabled ? stickyEnabledView : stickyDisabledView;
    let headerTitle = function getHeaderTitleBemClassName(hidden){
      return `${ bem('header-container')('post-title', { hidden, }) }`;
    };
    let headerMainActions = function getHeaderActionsBemClassName(hidden){
      return `${ bem('header-container')('header-main-actions', { hidden, }) }`;
    };

    if (vm.store.isStickyEnabled && isTablet && !viewport.isPortrait) {
      toggleBemClass(headerMainActions(false).split(" ").pop(), headerMainActions(true));
    } else {
      toggleBemClass(headerMainActions(true).split(" ").pop(), headerMainActions(false));
    }

    if (vm.store.hasTitle && (isDesktop || !viewport.isPortrait && isTablet)) {
      toggleBemClass(headerTitle(true).split(" ").pop(), headerTitle(false));
    }
    else {
      toggleBemClass(headerTitle(false).split(" ").pop(), headerTitle(true));
    }
    this.repositionMobileHeader(vm);
    return currentViewMethod.apply(this, [vm]);
  }

  repositionMobileHeader(vm){ // eslint-disable-line complexity
    if (isTablet && viewport.orientation === 'landscape') {
      removeHeaderMargins();
      return this;
    }
    if (isMobileOrTablet && pageDomain === '12up') {
      return this;
    }
    if (ads.isProSeven) {
      return this;
    }
    if (isMobileOrTablet || isIos) {
      addHeaderMargins(vm);
    }
    return this;
  }

  mobileHeaderOrientationHandler(vm) {
    addOnOrientationChangeEvent(() => {
      this.repositionMobileHeader(vm);
    }, () => {
      this.repositionMobileHeader(vm);
    });
  }

  stickyEnabledView(vm){
    return m(
      '.share-component.share-component--header',
      m(`.share-component__btns.${ platform.replace(' ', '_') }`, this.getSocialButtonViews(vm))
    );
  }

  stickyDisabledView(vm){
    return noop;
  }

  registerHamburgerActions(){
    return registerHamburger();
  }

}


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/views/socialButtons/NavbarView.js